import * as React from 'react';

import { cn } from '../../utils/cn';

export function AlertDialogHeader({
    className,
    ...props
}: React.ComponentProps<'div'>) {
    return (
        <div
            data-slot="alert-dialog-header"
            className={cn('flex flex-col gap-2 text-center', className)}
            {...props}
        />
    );
}
